"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CovidDetails = function CovidDetails() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      sdk = _ref.sdk,
      title = _ref.title,
      subtitle = _ref.subtitle,
      elementStyle = _ref.elementStyle,
      onEdit = _ref.onEdit,
      onEditLink = _ref.onEditLink,
      _ref$highlightEditBut = _ref.highlightEditButton,
      highlightEditButton = _ref$highlightEditBut === void 0 ? false : _ref$highlightEditBut,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator;

  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: title,
    subtitle: subtitle
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: elementStyle
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: _Colors.discreetTextColor
    }
  }, t('Due to safety measures put in place by the Ecuadorian government for the Covid-19 pandemic, you are required to provide some additional information about your trip.')), sdk.covid19.isCovid19InfoFilled() &&
  /*#__PURE__*/

  /*
    <table style={{ marginTop: 25 }}>
      <tbody>
        <tr>
          <td style={{ fontWeight: 'bold', paddingRight: 10 }}>{t('Leaving from:')}</td>
          <td style={{ textAlign: 'justify' }}>
            {sdk.covid19.getStringifiedInfo().originAddress}
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 'bold', paddingRight: 10 }}>{t('Going to:')}</td>
          <td style={{ textAlign: 'justify' }}>
            {sdk.covid19.getStringifiedInfo().destinationAddress}
          </td>
        </tr>
      </tbody>
    </table>
    */
  _react["default"].createElement("div", {
    style: {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 10,
      fontWeight: 'bold',
      paddingRight: 10
    }
  }, t('Leaving from:')), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'justify'
    }
  }, sdk.covid19.getStringifiedInfo().originAddress), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 10,
      fontWeight: 'bold',
      paddingRight: 10
    }
  }, t('Going to:')), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'justify'
    }
  }, sdk.covid19.getStringifiedInfo().destinationAddress)), (onEditLink || onEdit) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "edit-covid-details-button",
    to: onEditLink,
    onClick: onEdit,
    fluid: true,
    primary: highlightEditButton,
    style: {
      marginTop: 20
    }
  }, sdk.covid19.isCovid19InfoFilled() ? t('Edit this information') : t('Add my departure & arrival addresses'))));
};

var _default = CovidDetails;
exports["default"] = _default;